import createReducer from './_createReducerHelper';

export const ORIGINAL_BOARD = 'edit-history/ORIGINAL_BOARD';
export const ORIGINAL_CHARTS = 'edit-history/ORIGINAL_CHARTS';
export const IS_DIRTY = 'edit-history/IS_DIRTY';
export const SAVED_BOARD_STATE = 'edit-history/SAVED_BOARD_STATE';

const initialState = {
  originalBoard: null,
  originalCharts: null,
  isDirty: false,
  savedBoardState: false,
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [ORIGINAL_BOARD]: (state, { payload }) => ({ ...state, originalBoard: payload }),
  [ORIGINAL_CHARTS]: (state, { payload }) => ({ ...state, originalCharts: payload }),
  [IS_DIRTY]: (state, { payload }) => {
    window.onbeforeunload = () => payload || undefined;
    return { ...state, isDirty: payload };
  },
  [SAVED_BOARD_STATE]: (state, { payload }) => ({ ...state, savedBoardState: payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param board
 * @return {{type, payload: *}}
 */
export const originalBoard = (board) => ({
  type: ORIGINAL_BOARD,
  payload: board,
});
/**
 *
 * @param charts
 * @return {{type, payload: *}}
 */
export const originalCharts = (charts) => ({
  type: ORIGINAL_CHARTS,
  payload: charts,
});

/**
 *
 * @param dirty
 * @return {{type, payload: *}}
 */
export const isDirty = (dirty) => ({
  type: IS_DIRTY,
  payload: dirty,
});

/**
 *
 * @param saved
 * @return {{type, payload: *}}
 */
export const savedBoardState = (saved) => ({
  type: SAVED_BOARD_STATE,
  payload: saved,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 */
export const recallBoard = (state) => state.editHistory.originalBoard;
